/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaxeCommandDto } from './TaxeCommandDto';
import {
    TaxeCommandDtoFromJSON,
    TaxeCommandDtoFromJSONTyped,
    TaxeCommandDtoToJSON,
    TaxeCommandDtoToJSONTyped,
} from './TaxeCommandDto';
import type { BorneDto } from './BorneDto';
import {
    BorneDtoFromJSON,
    BorneDtoFromJSONTyped,
    BorneDtoToJSON,
    BorneDtoToJSONTyped,
} from './BorneDto';
import type { ReAssureurCommandDto } from './ReAssureurCommandDto';
import {
    ReAssureurCommandDtoFromJSON,
    ReAssureurCommandDtoFromJSONTyped,
    ReAssureurCommandDtoToJSON,
    ReAssureurCommandDtoToJSONTyped,
} from './ReAssureurCommandDto';
import type { CoAssureurCommandDto } from './CoAssureurCommandDto';
import {
    CoAssureurCommandDtoFromJSON,
    CoAssureurCommandDtoFromJSONTyped,
    CoAssureurCommandDtoToJSON,
    CoAssureurCommandDtoToJSONTyped,
} from './CoAssureurCommandDto';
import type { TarifCommandDto } from './TarifCommandDto';
import {
    TarifCommandDtoFromJSON,
    TarifCommandDtoFromJSONTyped,
    TarifCommandDtoToJSON,
    TarifCommandDtoToJSONTyped,
} from './TarifCommandDto';

/**
 * 
 * @export
 * @interface UpdateGarantieTunnelCommand
 */
export interface UpdateGarantieTunnelCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateGarantieTunnelCommand
     */
    tunnelId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGarantieTunnelCommand
     */
    garantieId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateGarantieTunnelCommand
     */
    isRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateGarantieTunnelCommand
     */
    designation: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGarantieTunnelCommand
     */
    descriptionCourte?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateGarantieTunnelCommand
     */
    descriptionLongue?: string | null;
    /**
     * Colonne « Franchise » du tableau des garanties des documents : HTML libre avec jetons {{CODE}} des variables du tunnel, résolus par dossier à la génération. Vide = texte par défaut du produit.
     * @type {string}
     * @memberof UpdateGarantieTunnelCommand
     */
    franchiseDetail?: string | null;
    /**
     * Colonne « Plafond » du tableau des garanties des documents, même mécanique.
     * @type {string}
     * @memberof UpdateGarantieTunnelCommand
     */
    plafondDetail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateGarantieTunnelCommand
     */
    iconeId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateGarantieTunnelCommand
     */
    ordreAffichage?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateGarantieTunnelCommand
     */
    garantieParentId?: string | null;
    /**
     * 
     * @type {TarifCommandDto}
     * @memberof UpdateGarantieTunnelCommand
     */
    tarification: TarifCommandDto;
    /**
     * 
     * @type {Array<BorneDto>}
     * @memberof UpdateGarantieTunnelCommand
     */
    franchises?: Array<BorneDto>;
    /**
     * 
     * @type {Array<BorneDto>}
     * @memberof UpdateGarantieTunnelCommand
     */
    plafonds?: Array<BorneDto>;
    /**
     * Compagnie porteur de risque principale (PersonneMorale de nature CIE).
     * @type {string}
     * @memberof UpdateGarantieTunnelCommand
     */
    assureurPersonneMoraleId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGarantieTunnelCommand
     */
    compteBancaireId: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateGarantieTunnelCommand
     */
    tauxQP?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateGarantieTunnelCommand
     */
    aperition?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof UpdateGarantieTunnelCommand
     */
    dateDebut?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateGarantieTunnelCommand
     */
    dateFin?: Date | null;
    /**
     * 
     * @type {TaxeCommandDto}
     * @memberof UpdateGarantieTunnelCommand
     */
    taxeProfessionelle?: TaxeCommandDto;
    /**
     * 
     * @type {TaxeCommandDto}
     * @memberof UpdateGarantieTunnelCommand
     */
    taxeParticulier?: TaxeCommandDto;
    /**
     * 
     * @type {Array<CoAssureurCommandDto>}
     * @memberof UpdateGarantieTunnelCommand
     */
    coAssureurs?: Array<CoAssureurCommandDto>;
    /**
     * 
     * @type {Array<ReAssureurCommandDto>}
     * @memberof UpdateGarantieTunnelCommand
     */
    reAssureurs?: Array<ReAssureurCommandDto>;
    /**
     * 
     * @type {string}
     * @memberof UpdateGarantieTunnelCommand
     */
    garantieTunnelId: string;
}

/**
 * Check if a given object implements the UpdateGarantieTunnelCommand interface.
 */
export function instanceOfUpdateGarantieTunnelCommand(value: object): value is UpdateGarantieTunnelCommand {
    if (!('tunnelId' in value) || value['tunnelId'] === undefined) return false;
    if (!('garantieId' in value) || value['garantieId'] === undefined) return false;
    if (!('designation' in value) || value['designation'] === undefined) return false;
    if (!('tarification' in value) || value['tarification'] === undefined) return false;
    if (!('assureurPersonneMoraleId' in value) || value['assureurPersonneMoraleId'] === undefined) return false;
    if (!('compteBancaireId' in value) || value['compteBancaireId'] === undefined) return false;
    if (!('garantieTunnelId' in value) || value['garantieTunnelId'] === undefined) return false;
    return true;
}

export function UpdateGarantieTunnelCommandFromJSON(json: any): UpdateGarantieTunnelCommand {
    return UpdateGarantieTunnelCommandFromJSONTyped(json, false);
}

export function UpdateGarantieTunnelCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGarantieTunnelCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'tunnelId': json['tunnelId'],
        'garantieId': json['garantieId'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'designation': json['designation'],
        'descriptionCourte': json['descriptionCourte'] == null ? undefined : json['descriptionCourte'],
        'descriptionLongue': json['descriptionLongue'] == null ? undefined : json['descriptionLongue'],
        'franchiseDetail': json['franchiseDetail'] == null ? undefined : json['franchiseDetail'],
        'plafondDetail': json['plafondDetail'] == null ? undefined : json['plafondDetail'],
        'iconeId': json['iconeId'] == null ? undefined : json['iconeId'],
        'ordreAffichage': json['ordreAffichage'] == null ? undefined : json['ordreAffichage'],
        'garantieParentId': json['garantieParentId'] == null ? undefined : json['garantieParentId'],
        'tarification': TarifCommandDtoFromJSON(json['tarification']),
        'franchises': json['franchises'] == null ? undefined : ((json['franchises'] as Array<any>).map(BorneDtoFromJSON)),
        'plafonds': json['plafonds'] == null ? undefined : ((json['plafonds'] as Array<any>).map(BorneDtoFromJSON)),
        'assureurPersonneMoraleId': json['assureurPersonneMoraleId'],
        'compteBancaireId': json['compteBancaireId'],
        'tauxQP': json['tauxQP'] == null ? undefined : json['tauxQP'],
        'aperition': json['aperition'] == null ? undefined : json['aperition'],
        'dateDebut': json['dateDebut'] == null ? undefined : (new Date(json['dateDebut'])),
        'dateFin': json['dateFin'] == null ? undefined : (new Date(json['dateFin'])),
        'taxeProfessionelle': json['taxeProfessionelle'] == null ? undefined : TaxeCommandDtoFromJSON(json['taxeProfessionelle']),
        'taxeParticulier': json['taxeParticulier'] == null ? undefined : TaxeCommandDtoFromJSON(json['taxeParticulier']),
        'coAssureurs': json['coAssureurs'] == null ? undefined : ((json['coAssureurs'] as Array<any>).map(CoAssureurCommandDtoFromJSON)),
        'reAssureurs': json['reAssureurs'] == null ? undefined : ((json['reAssureurs'] as Array<any>).map(ReAssureurCommandDtoFromJSON)),
        'garantieTunnelId': json['garantieTunnelId'],
    };
}

export function UpdateGarantieTunnelCommandToJSON(json: any): UpdateGarantieTunnelCommand {
    return UpdateGarantieTunnelCommandToJSONTyped(json, false);
}

export function UpdateGarantieTunnelCommandToJSONTyped(value?: UpdateGarantieTunnelCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tunnelId': value['tunnelId'],
        'garantieId': value['garantieId'],
        'isRequired': value['isRequired'],
        'designation': value['designation'],
        'descriptionCourte': value['descriptionCourte'],
        'descriptionLongue': value['descriptionLongue'],
        'franchiseDetail': value['franchiseDetail'],
        'plafondDetail': value['plafondDetail'],
        'iconeId': value['iconeId'],
        'ordreAffichage': value['ordreAffichage'],
        'garantieParentId': value['garantieParentId'],
        'tarification': TarifCommandDtoToJSON(value['tarification']),
        'franchises': value['franchises'] == null ? undefined : ((value['franchises'] as Array<any>).map(BorneDtoToJSON)),
        'plafonds': value['plafonds'] == null ? undefined : ((value['plafonds'] as Array<any>).map(BorneDtoToJSON)),
        'assureurPersonneMoraleId': value['assureurPersonneMoraleId'],
        'compteBancaireId': value['compteBancaireId'],
        'tauxQP': value['tauxQP'],
        'aperition': value['aperition'],
        'dateDebut': value['dateDebut'] == null ? undefined : ((value['dateDebut'] as any).toISOString()),
        'dateFin': value['dateFin'] == null ? undefined : ((value['dateFin'] as any).toISOString()),
        'taxeProfessionelle': TaxeCommandDtoToJSON(value['taxeProfessionelle']),
        'taxeParticulier': TaxeCommandDtoToJSON(value['taxeParticulier']),
        'coAssureurs': value['coAssureurs'] == null ? undefined : ((value['coAssureurs'] as Array<any>).map(CoAssureurCommandDtoToJSON)),
        'reAssureurs': value['reAssureurs'] == null ? undefined : ((value['reAssureurs'] as Array<any>).map(ReAssureurCommandDtoToJSON)),
        'garantieTunnelId': value['garantieTunnelId'],
    };
}

